import { NgModule, ApplicationRef } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { FormsModule } from "@angular/forms";
import { HttpModule, JsonpModule } from "@angular/http";
import { HttpClientModule } from "@angular/common/http";

import { MainPageComponent } from "Components/main-page.component";
import { LoginComponent } from "Components/login.component";
import { LandingPageComponent } from "Components/landing-page.component";
import { AccountInfoComponent } from "Components/account-info.component";
import { AdminManagementComponent } from "Components/admin-management.component";
import { CreateUserComponent } from "Components/create-user.component";
import { ManageUsersComponent } from "Components/manage-users.component";
import { ChangePasswordComponent } from "Components/change-password.component";
import { EditInfoComponent } from "Components/edit-info.component";
import { NavigationBarComponent } from "Components/navigation-bar.component";
import { UISpinnerComponent } from "Components/ui-spinner.component";
import { GridComponent } from "Components/grid.component";
import { ModalWindowComponent } from "Components/modal-window.component";

import { CookieService } from "angular2-cookie/core";
import { CookieManagementService } from "Services/cookie-management.service";
import { MultiselectDropdownModule } from "angular-2-dropdown-multiselect";
import { FetchDataService } from "Services/fetch-data.service";
import { EventService } from "Services/event.service";
import { GridService } from "Services/grid.service";
import { AuthenticationService } from "Services/authentication.service";
import { ConfigService } from "Services/config.service";
import { AppConfig } from "Classes/AppConfig";
import { ColModels } from "Classes/ColModels";

import { SafePipe } from "Pipes/safe.pipe";

//import { AdalService } from "ng2-adal/dist/core";
import { Adal4Service as AdalService } from 'adal-angular4';

@NgModule({
    imports: [
        BrowserModule,
        FormsModule,
        HttpModule,
        HttpClientModule,
        MultiselectDropdownModule,
        BrowserAnimationsModule
    ],
    declarations: [
        // Components that will be used in module
        MainPageComponent,
        LoginComponent,
        LandingPageComponent,
        AccountInfoComponent,
        AdminManagementComponent,
        CreateUserComponent,
        ManageUsersComponent,
        ChangePasswordComponent,
        EditInfoComponent,
        NavigationBarComponent,
        UISpinnerComponent,
        GridComponent,
        ModalWindowComponent,
        // Pipes
        SafePipe
    ],
    // The component to bootstrap from
    bootstrap: [MainPageComponent],
    // Providers that will be used in module (Services)
    providers: [
        AdalService,
        FetchDataService,
        EventService,
        GridService,
        CookieService,
        CookieManagementService,
        AuthenticationService,
        ConfigService,
        AppConfig,
        ColModels
    ]
})
export class AppModule {
    constructor(private _appRef: ApplicationRef) { }

    ngDoBootstrap(): void {
        this._appRef.bootstrap(MainPageComponent);
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./App/app.module.ts